export interface MapData {
  orderHash?: string;
  licensePlate?: string;
  brand?: string;
  model?: string;
  lat?: number | null;
  lng?: number | null;
  orderStatus?: number;
  active?: boolean | undefined;
  icon?: google.maps.Icon
  type?: MapMarkerType;
  addressId?: string;
}

export enum MapMarkerType {
  ORIGIN = "ORIGIN",
  DESTINATION = "DESTINATION",
  DRIVER = "DRIVER",
}





